export default "__VITE_ASSET__vjgZOqF2__"